import { EventrDate } from '@eventr/common'
import {
    ColoursObj,
    Typography,
    getContrastYIQ,
} from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { useShallow } from 'zustand/react/shallow'
import { useLanguageContext } from '../../../state/languageState/languageContext'
import { CarouselItineraryTags } from './slide/newComps/itineraryTags'
export function ItineraryDateWindow({
    id,
    start,
    end,
    tags,
}: {
    id?: string
    start?: string
    end?: string
    tags?: number[]
}) {
    const { getLanguageISO639Code } = useLanguageContext(
        useShallow((s) => {
            return {
                getLanguageISO639Code: s.getLanguageISO639Code,
            }
        })
    )

    // Ensure the start and end dates are valid.
    if (!start || !end) return null

    const parsedStart = new EventrDate(start)
    const parsedEnd = new EventrDate(end)

    const styledStart = parsedStart.toItinLocalStyledShortDateString(
        getLanguageISO639Code()
    )
    const styledEnd = parsedEnd.toItinLocalStyledShortDateString(
        getLanguageISO639Code()
    )

    // Ensure the start and end dates are styled appropriately.
    if (styledStart === '' || styledEnd === '') return null

    return (
        <Box display={'grid'} justifyItems={'center'} gap={'4px'}>
            <Box
                display={'grid'}
                gridAutoFlow={'column'}
                gap={'8px'}
                alignItems={'center'}
                width={'max-content'}
            >
                <Typography
                    id={`${id}itinerary-date-range-start-date`}
                    variant="bodySubtext"
                    align="center"
                    color={getContrastYIQ(ColoursObj.backgrounds.header)}
                    style={{
                        transition: '0.5s',
                    }}
                >
                    {styledStart}
                </Typography>
                <Box
                    sx={{
                        height: '1px',
                        width: '6px',
                        backgroundColor: getContrastYIQ(
                            ColoursObj.backgrounds.header
                        ),
                    }}
                />
                <Typography
                    id={`${id}itinerary-date-range-end-date`}
                    variant="bodySubtext"
                    align="center"
                    color={getContrastYIQ(ColoursObj.backgrounds.header)}
                    style={{
                        transition: '0.5s',
                    }}
                >
                    {styledEnd}
                </Typography>
            </Box>
            <Box>
                <CarouselItineraryTags id={`${id}itinerary-tags`} tags={tags || []} />
            </Box>
        </Box>
    )
}
